import { createAction } from 'redux-actions';

export const formFindersLoadExisting = createAction('FORMFINDERS_LOADEXISTING');
export const formFindersLoaded = createAction('FORMFINDERS_LOADED');

export const formFinderSelect = createAction('FORMFINDER_SELECT');
